import React from 'react';
import { Grid, Table, Button } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const fontStyle = {
  fontWeight: 300,
  fontSize: '1.3em',
  color: '#555'
};

const ProductActions = ({ history }) => (
  <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Product Actions</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Product Actions
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row centered>
      <Grid.Column width={8}>
        <Table celled fixed style={{ marginTop: '8em' }}>
          <Table.Body>
            <Table.Row>
              <Table.Cell style={fontStyle}>Manufacturer Variants</Table.Cell>
              <Table.Cell>
                <Button basic color="blue" onClick={() => history.push('/products')}>
                  {' '}
                  List{' '}
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button basic color="teal" onClick={() => history.push('/products/mvs')}>
                  {' '}
                  Create{' '}
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button basic color="violet" onClick={() => history.push('/products/mvs/update')}>
                  {' '}
                  Update{' '}
                </Button>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell style={fontStyle}>Variants</Table.Cell>
              <Table.Cell>
                <Button basic color="blue" disabled>
                  {' '}
                  List{' '}
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button basic color="teal" onClick={() => history.push('/products/variants')}>
                  {' '}
                  Create{' '}
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button
                  basic
                  color="violet"
                  onClick={() => history.push('/products/variants/update')}
                >
                  {' '}
                  Update{' '}
                </Button>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell style={fontStyle}>Products</Table.Cell>
              <Table.Cell>
                <Button basic color="blue" disabled>
                  {' '}
                  List{' '}
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button basic color="teal" onClick={() => history.push('/products/new')}>
                  {' '}
                  Create{' '}
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button basic color="violet" onClick={() => history.push('/products/update')}>
                  {' '}
                  Update{' '}
                </Button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default withRouter(ProductActions);



// WEBPACK FOOTER //
// ./src/Modules/ProductActions/component.jsx